<template>
    <form method="POST" id="searchForm" class="AutocompleteComponent searchForm" action="">

        <div class="Autocomplete-input" v-show="!this.getClubSelected">
            <div class="input-group">
                <input type="text" name="q" id="searchField" class="form-control" placeholder="Rechercher..."
                       autocomplete="off"
                       v-model="query"
                       @keydown.down="down"
                       @keydown.up="up"
                       @keydown.enter="hit"
                       @keydown.esc="reset"
                       @input="update"
                />
                <span class="input-group-btn">
                    <button type="submit" name="search" id="search-btn" class="btn btn-flat">
                        <i class="fa"
                           :class="{'fa-search':!loading, 'fa-refresh': loading, 'fa-spin':loading }">
                        </i>
                    </button>
                </span>
            </div>
        </div>

        <ul class="results" v-show="showResults"
            :style="{ height: sizeOfResultBox + 'px' }"
        >
            <li v-show="!hasItems">
                <div class="results_container">
                    <div class="image">
                    </div>
                    <div class="description">
                        <span class="titre red">Pas de résultat trouvé</span><br>
                    </div>
                </div>
            </li>
            <li v-show="hasItems" class="ui-menu-item" role="presentation" v-for="(item,$index) in items"
                :class="activeClass($index)" @mousedown="hit($index)" @mousemove="setActive($index)">
                <a href="#" :id="'ui-id-'+item.id" class="ui-corner-all" tabindex="-1"
                   @click="onClick($event,$index)">
                    <div class="results_container">
                        <div class="image">
                            <i class="glyphicon glyphicon-home iconResults"></i>
                        </div>
                        <div class="description">
                            <span class="titre">  {{item.numero_club}} {{item.club}}</span><br>
                            <span class="desc"><span
                                    :class="{ 'green':item.licencie, 'red':!item.licencie }">{{ item.licencie ? 'Licencié' : 'Non-licencié'}}</span> - {{item.totalMembres}} membres </span>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
    </form>
</template>


<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {
                items: [],
                query: '',
                current: -1,
                loading: false,
                queryParamName: 'q',
                src: '',
                previousRequest: false,
                showResults: false,
                sizeOfResultBox:400,
                defaultSizeForOneItem:60,
                routeSearchRole:""
            }
        },
        computed: {
            ...mapGetters({
                getClubSelected: 'getClubSelected',
                getRoute:'getRoute'
            }),
            hasItems() {
                return this.items.length > 0
            },
            isEmpty() {
                return !this.query
            },
            isDirty() {
                return !!this.query
            }
        },
        props: {
            urlApi: String,
            srcSpinner: String,
            limit: {
                type:Number,
                default: function () {
                    return 5
                }
            } ,
            minChars: Number,
            idOther: Number,
            FollowLinkOnClickOnItem: Boolean,
            actionOnHit: {
                type: String,
                default: "default"
            },
        },
        methods: {
            ...mapActions({
                majClubSelected: "majClubSelected",
                addToAllClubsSelected: "addToAllClubsSelected",
                majLoadingModalOperation:"majLoadingModalOperation"
            }),
            update() {
                if (!this.query) {
                    return this.reset()
                }

                if (this.minChars && this.query.length < this.minChars) {
                    return
                }

                this.loading = true
                this.fetch().then(function (response) {
                    if (this.query) {
                        let data = response.data
                        data = this.prepareResponseData ? this.prepareResponseData(data) : data
                        this.items = data
                        this.current = -1
                        this.loading = false
                        this.showResults = true
                    }
                })
            },
            fetch() {
                if (!this.$http) {
                    return console.log('You need to install the `vue-resource` plugin')
                }

                if (!this.src) {
                    return console.log('You need to set the src prop')
                }

                const params = this.queryParamName
                    ? Object.assign({[this.queryParamName]: this.query}, this.data)
                    : this.data

                const src = this.src + '?q=' + this.query

                return this.$http.get(src, {
                    before(request) {
                        // abort previous request, if exists
                        if (this.previousRequest) {
                            this.previousRequest.abort();
                        }
                        // set previous request on Vue instance
                        this.previousRequest = request;
                        this.loading = true
                    }
                })
            },
            reset() {
                this.items = []
                this.query = ''
                this.loading = false
            },
            setActive(index) {
                this.current = index
            },
            activeClass(index) {
                return {
                    active: this.current === index
                }
            },
            hit() {
                if (this.current !== -1) {
                    this.onHit(this.items[this.current])
                }
            },
            up() {
                if (this.current > 0) {
                    this.current--
                } else if (this.current === -1) {
                    this.current = this.items.length - 1
                } else {
                    this.current = -1
                }
            },
            down() {
                if (this.current < this.items.length - 1) {
                    this.current++
                } else {
                    this.current = -1
                }
            },
            onHit(index) {
                switch (this.actionOnHit) {
                    case 'default':
                        var these=this;
                        this.showResults = false
                        this.$http.post(this.getRoute('routeOnHitClub'),{id_club:index.id}).then(function (response) {
                            let data = response.data
                            data = this.prepareResponseData ? this.prepareResponseData(data) : data
                            these.majClubSelected(data);
                        }, (response) => {
                        });

                        break
                    case 'majAllClubsSelected':
                        var these=this;
                        this.majLoadingModalOperation(true)
                        this.showResults = false
                        this.$http.post(this.getRoute('roleSearch'), {meta: 'concernePar'}).then(function (response) {
                            let data = response.data
                            data = this.prepareResponseData ? this.prepareResponseData(data) : data
                            this.addToAllClubsSelected({role:data, club:index});
                            these.majLoadingModalOperation(false)
//                            var n = noty({text: "", type: "success"});
                        }, (response) => {
                            these.majLoadingModalOperation(false)
//                            var n = noty({text: data, type: "error"});
                        });
                        break
                }
            },
            onClick(event, index) {
                if (!this.FollowLinkOnClickOnItem) {
                    event.preventDefault()
                }
            }
        },
        watch: {
            items: function (value) {
                this.sizeOfResultBox=this.limit*this.defaultSizeForOneItem
                if (value.length>this.limit)
                    this.sizeOfResultBox=this.limit*this.defaultSizeForOneItem
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.routeSearchRole=this.getRoute('roleSearch');
                if (this.urlApi == "" || typeof (this.urlApi) == "undefined")
                    this.src = this.getRoute('clubSearch')
                else
                    this.src = this.urlApi;
            });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Communs/searchClub.vue